import { formatNumber, formatUsd } from 'lib/display/formatting';

import { ChartProps } from '../chartTypes';
import {
  IChartWidgetApi,
  IOrderLineAdapter,
} from '../external/charting_library';

import { NEGATIVE_COLOR, POSITIVE_COLOR } from './drawingColors';
import {
  removeTpSlHandle,
  renderPositionTPSLHandle,
  updateCurrentTpSlOrderLine,
} from './positionTPSLHandle';

/** Positions rendered on chart */
let positionLine: IOrderLineAdapter | undefined;

// let positionLineShapeId: EntityId | null = null;

export function renderPosition(
  chart: IChartWidgetApi | undefined,
  {
    position,
    stepSizes,
    onChangeTPSLPrice,
  }: Pick<ChartProps, 'position' | 'stepSizes' | 'onChangeTPSLPrice'>,
  dragging: boolean
) {
  if (!chart) {
    return;
  }
  // We have to always remove, otherwise it fails to render sometimes (eg. chart instance swap?)
  positionLine?.remove();
  positionLine = undefined;
  if (!dragging) {
    removeTpSlHandle();
  }
  if (!position) {
    return;
  }
  const entryPrice = Number(position.entryPrice);
  // if (entryPrice !== positionLine?.getPrice()) {
  //   // Could be different market or position changed
  //   positionLine?.remove();
  //   positionLine = undefined;
  // }
  const [baseSymbol] = position.market.split('-');
  const positionColor =
    Number(position.quantity) >= 0 ? POSITIVE_COLOR : NEGATIVE_COLOR;

  // if (positionLineShapeId) {
  //   chart.removeEntity(positionLineShapeId);
  // }
  // positionLineShapeId = chart.createShape(
  //   { price: entryPrice, time: Date.now() },
  //   { shape: 'horizontal_line', lock: true, disableSelection: true }
  // );

  if (!positionLine) {
    // We are using Order because otherwise Position line would be drawn over TPSL shape
    //  Prev: createPositionLine - but we are not using any extar from position so we are fine
    positionLine = chart.createOrderLine();
  }
  const PNLText = `P&L ${
    Number(position.unrealizedPnL) < 0 ? '' : '+'
  }${formatUsd(position.unrealizedPnL)}`;

  const quantityText = `${formatNumber(position.quantity, {
    fixedDecimals: stepSizes[position.market]?.visibleDecimals,
  })} ${baseSymbol}`;

  positionLine
    .setBodyBackgroundColor('#000')
    // .setLineColor('#00000000')
    .setLineColor(positionColor)
    .setBodyBorderColor(positionColor)
    .setQuantityBackgroundColor(positionColor)
    .setQuantityBorderColor(positionColor)
    .setBodyTextColor('white')
    .setText(PNLText)
    .setPrice(entryPrice)
    .setQuantity(quantityText)
    // Move it more to the left
    .setExtendLeft(false)
    .setLineStyle(0)
    .setLineLength(-8, 'pixel');

  /** To help estimate offset of TPSL handle */
  const positionTextLength = PNLText.length + quantityText.length;

  if (dragging) {
    updateCurrentTpSlOrderLine(position);
  } else {
    renderPositionTPSLHandle(
      chart,
      { position, onChangeTPSLPrice },
      positionTextLength
    );
  }
}
